import Link from "../Link";

const Python = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/6" title={"OpenBootcamp Python"} />
        </div>
    );
}

export default Python;